export default "__VITE_ASSET__CsYJAvAw__"